export const FOCUSABLE_ELS_SELECTOR =
  'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
